import { toggleMenu } from "../_src/components/dropdown";
import { purify } from "../_src/components/purify";

export function getQuestions(id) {
  function search(content) {

    document.querySelectorAll(`#filter-${id} button`).forEach(function (el) {
      el.classList.add("disabled")
    })

    document.querySelector(".loader-help").classList.remove("hidden")

    var form = document.querySelector(`#filter-${id} form`);
    var data = new FormData(form);

    document.querySelector("#term").classList.add("loading")

    fetch(`/ajuda/ajax/help.html/?content=${content}`, {
        method: "POST",
        body: data
      }).then((response) => {
        return response.text();
      }).then((response) => {
        document.querySelector(`#result-${id}`).innerHTML = purify(response);
      }).catch((error) => {
        console.error(error);
      }).finally(() => {
        toggleMenu();

        document.querySelector(".loader-help").classList.add("hidden")

        document.querySelectorAll(`#filter-${id} button`).forEach(function (el) {
          el.classList.remove("disabled")
        })

        document.querySelector("#term").classList.remove("loading")
      });
  }

  document.querySelectorAll(`[data-action=select-content]`).forEach(function (btn) {
    btn.addEventListener("click", function () {
      if (this.classList.contains("active")) {
        return
      }

      document.querySelectorAll(`[data-action=select-content]`).forEach(function (btn) {
        btn.classList.remove("active")
      })

      this.classList.add("active")
      search(this.dataset.content)
    })
  })

  document.querySelector("#term").parentElement.parentElement.addEventListener("submit", function (e) {
    e.preventDefault();

    search(document.querySelector(`#filter-${id} .active`).dataset.content)
  })

  return search(document.querySelector(`#filter-${id} .active`).dataset.content)
}

if (document.querySelector("#result-questions")) {
  getQuestions("questions");
}
